var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M210 40c16.569 0 30 13.432 30 30v140c0 16.569-13.431 30-30 30H70c-16.568 0-30-13.431-30-30V70c0-16.568 13.432-30 30-30zm-20 40h-55.858c-8.909 0-13.371 10.771-7.071 17.071L145 115l-47.929 47.929c-3.905 3.905-3.905 10.237 0 14.142l5.858 5.858c3.905 3.905 10.237 3.905 14.142 0L165 135l17.929 17.929c6.3 6.3 17.071 1.838 17.071-7.071V90c0-5.523-4.477-10-10-10"
})));
export default SvgExpandArrow;